import constants from "../../../core/constants";
import findIndex from "lodash/fp/findIndex";

class Controller {
  constructor($mdDialog, selected, currency) {
    "ngInject";
    this.currency = currency;
    const values = [
      { off: false, percentage: true, value: null },
      { off: false, percentage: false, value: null },
      { off: true, percentage: true, value: null },
      { off: true, percentage: false, value: null },
    ];
    const getValue = (value) =>
      value.off === selected.off && value.percentage === selected.percentage;
    const value = selected ? selected.value : null;
    const valueIndex = selected ? findIndex(getValue)(values) : -1;
    const getValues = () => {
      values[valueIndex].value = value;

      return values;
    };

    this.$mdDialog = $mdDialog;
    this.values = selected ? getValues() : values;
    this.promoValue = selected ? values[valueIndex] : null;
    this.times = selected ? selected.times : null;
    this.maximum = selected ? selected.maximum : null;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    let formattedPromo = Object.assign({ times: this.times }, this.promoValue, {
      maximum: this.maximum * constants.currencyBy,
    });

    if (!this.promoValue.percentage) {
      formattedPromo = Object.assign(formattedPromo, {
        value: this.promoValue.value * constants.currencyBy,
      });
    }
    this.$mdDialog.hide(formattedPromo);
  }

  onChange() {
    if (this.promoValue.value && this.times && this.maximum) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/promotionValue/dialog/dialog.controller.js